import { get } from "../../helper/Api_helper";
import { TENANTS_APPLICATION_STAGES_LIST, VYLABS_BASE_URL } from "../../helper/url_helper";
import { TENANT_CORE_API_KEY } from "../../Tenant-Config/TenantConfig";
import { toCapitalize } from "../Common-Function/CommonFunctions";

const CACHE_TTL_MS = 5 * 60 * 1000;
let stageCache = null;

export const invalidateCallStagesCache = () => {
  stageCache = null;
};

export const fetchActiveCallStages = () => {
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  const scope = JSON.stringify([VYLABS_BASE_URL, TENANT_CORE_API_KEY, token]);

  if (stageCache?.scope === scope) {
    if (stageCache.pending) return stageCache.pending;
    if (Date.now() < stageCache.expiresAt) return Promise.resolve(stageCache.stages);
  }

  const entry = { scope, pending: null, stages: null, expiresAt: 0 };
  stageCache = entry;
  entry.pending = (async () => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        TENANTS_APPLICATION_STAGES_LIST + "?active=true",
        { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );
      const stages = Array.isArray(response) ? response : response?.stages || [];
      if (!Array.isArray(stages)) throw new Error("Invalid call stages response");

      entry.stages = stages;
      entry.expiresAt = Date.now() + CACHE_TTL_MS;
      return stages;
    } catch (error) {      
      if (stageCache === entry) stageCache = null;
      throw error;
    } finally {
      entry.pending = null;
    }
  })();

  return entry.pending;
};

export const fetchCallStages = async () => {
  try {
    const stages = await fetchActiveCallStages();
      return stages.reduce((map, stage) => {
        if (stage?.system_key && stage?.name) {
          map[stage.system_key] = toCapitalize(stage.name);
        }
        return map;
      }, {});
    } catch (error) {
      console.error("Error fetching call stages:", error);
      return {};
    }
  };